<template>
  <v-container fluid>
    <div>
      <v-layout>
        <v-flex pb-2 class="headline">Active Alerts</v-flex>
      </v-layout>
      <v-flex v-if="groupedAlerts === null" xs12 py-2>
        <span class="alerts__subheader error--text">An error occurred requesting alerts</span>
      </v-flex>
      <v-flex v-else-if="groupedAlerts.length === 0" xs12>
        <span class="alerts__subheader" style="font-size: 16px">No active alerts currently</span>
      </v-flex>
    </div>
    <v-layout v-for="(g, gi) in groupedAlerts" :key="gi" row wrap>
      <v-flex xs12 py-2>
        <span class="title">{{ g.group }}</span>
      </v-flex>
      <v-flex v-for="(a, i) in g.alerts" :key="i" py-2>
        <v-card max-width="450px" flat>
          <v-card-title>
            <span pa-2 class="subheading">{{ a.categoryText }} - {{ a.featureText }}</span>
          </v-card-title>
          <v-card-text>
            <v-layout align-center wrap>
              <v-flex xs12 sm4 md4 py-2>
                <div class="label">Impact</div>
                <div>
                  <span>{{ a.priorityText }}</span>
                </div>
              </v-flex>

              <v-flex xs12 sm4 md3 py-2>
                <div class="label">Impact Scope</div>
                <div>
                  {{ a.affected }}
                </div>
              </v-flex>

              <v-flex xs12 sm4 md4 py-2>
                <div class="label">Start Time</div>
                <div>
                  {{ a.startTime | formatTime }}
                </div>
              </v-flex>

              <v-flex xs12 py-2>
                <div class="label">Message</div>
                <div v-html="a.message"></div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { formatTime } from '@/filters/filters.js';
import { mapState, mapGetters } from 'vuex';

export default {
  filters: { formatTime },
  data: function () {
    return {
      alerts: []
    };
  },
  computed: {
    ...mapState(['features', 'priorities', 'categories', 'recipientTypes']),
    ...mapGetters(['groupedAlerts'])
  }
};
</script>

<style scoped>
  .label {
    font-size: 12px;
    color: rgba(0,0,0, .54);
  }

</style>
